import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkSlash } from '@fortawesome/pro-solid-svg-icons';
import { CharlieSkeleton } from '@ver.id/libs.ui.charlie';
import { useTranslation } from '../../i18n/i18n';

type RequestedDataPlaceholderProps = {
  loading: boolean;
  isIssuance: boolean;
};

/**
 * Placeholder for the requested data section before data is available.
 * Shows a skeleton when loading, or an "indeterminate" hint when idle
 * (e.g. waiting for app selection).
 */
export default function RequestedDataPlaceholder({
  loading,
  isIssuance,
}: RequestedDataPlaceholderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-base font-semibold text-sidebar-foreground leading-6">
        {isIssuance
          ? t('sidebar.issuedDataTitle')
          : t('sidebar.requestedDataTitle')}
      </h3>
      <div className="rounded-md border border-border bg-card p-2">
        {loading ? (
          <div className="flex flex-col gap-1 rounded-sm p-2">
            <CharlieSkeleton className="h-4 w-24" />
            <CharlieSkeleton className="h-3 w-40" />
          </div>
        ) : (
          <div className="flex flex-col items-center gap-3 rounded-sm px-4 py-6 text-center">
            <FontAwesomeIcon
              icon={faLinkSlash}
              className="size-6 text-muted-foreground"
            />
            <span className="text-sm text-muted-foreground">
              {t('sidebar.indeterminateHint')}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
